import { makeStyles } from '@mui/styles';
const skeletonLoadersStyles = makeStyles({
    root: {
        width: '100%',
    },
}, { name: 'SkeletonLoaders' });
export default skeletonLoadersStyles;
//# sourceMappingURL=skeletonLoaders.styles.js.map